import React, { useContext } from "react";
import "../.././Faultanalysis/GlossaryPageFaultanalysis.css"
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain from '../../DashboardMain/DashboardMain';
import AppContext from '../../../../store/AppContext';
import { useState } from "react";

function GlossaryPageFaultanalysis() {
    const app_ctx = useContext(AppContext);
    return (
        <>
            <DashboardMain>
                <body style={{ backgroundColor: "white" }}>
                    <h1 style={{ fontWeight: 'bold', marginTop: "6em", fontSize: "2em" }} align="center">Glossary Page<Link to="/dashboard/charginganalysis" style={{ color: "#32879c", marginLeft: "5%", fontSize: '0.7em' }}><BsSkipBackwardCircleFill /></Link></h1>
                    <table className="table table-hover tableglosary" style={{ width: "50%", height: "20%" }} align="center">
                        <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                            <tr>
                                <th scope="col">Sr.No.</th>
                                <th scope="col">KPI name</th>
                                <th scope="col">Business Logics</th>
                                <th scope="col">Backend Formula</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Total Vehicle Count
                                    Slow Vehicle Count
                                    Fast Vehicle Count
                                    Both Vehicle Count
                                </td>
                                <td>Count of Vehicle for selected date range
                                    Count of Vehicle who has done only Slow charging for selected date range
                                    Count of Vehicle who has done only Fast charging for selected date range
                                    Count of Vehicle who has done slow and Fast charging for selected date range
                                </td>
                                <td>Distinct Count (VIN)
                                    Distinct Count (VIN) and charge type = Slow
                                    Distinct Count (VIN) and charge type = Fast
                                    Distinct Count (VIN) and charge type = Slow and Fast
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Total Charging Cycles
                                    Total Slow Cycles
                                    Total Fast Cycles
                                </td>
                                <td>Total number of charging cycles
                                    Total number of slow charging cycles
                                    Total number of fast charging cycles
                                    for selected date range
                                </td>
                                <td>Sum ( Fast + Slow Cycles)
                                    Sum (cycles with Charge Type = Slow)
                                    Sum (cycles with Charge Type = Fast)
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Total Faulty Cycles
                                    Total Faulty Slow Cycles
                                    Total Faulty Fast Cycles
                                </td>
                                <td>Total cycles with atleast one HV_Charge_Indication=0
                                    Total slow cycles with atleast one HV_Charge_Indication=0
                                    Total fast cycles with atleast one HV_Charge_Indication=0
                                    for selected date range
                                </td>
                                <td>Sum ( Faulty Fast + Faulty Slow Cycles)
                                    Sum (Slow cycles with HV_Charge_Indication=0 and Charge Type = Slow)
                                    Sum (Fast cycles with HV_Charge_Indication=0 Charge Type = Fast)
                                </td>
                            </tr> <tr>
                                <td>4</td>
                                <td>Total Opportunity Cycles
                                    Opportunity Charge (Slow)
                                    Opportunity Charge (Fast)
                                </td>
                                <td>Total number of Opportunity charging cycles where End SoC {"< 100"}
                                    Total number of slow charging cycles where End SoC {" < 100"}
                                    Total number of fast charging cycles where End SoC {"< 100"}
                                    for selected date range
                                </td>
                                <td>Sum (charging Cycles where End SoC {"< 100"} and charge type = Slow and Fast)
                                    Sum (charging Cycles where End SoC {"< 100"} and charge type = Slow )
                                    Sum (charging Cycles where End SoC {"< 100"} and charge type = Fast )
                                </td>
                            </tr> <tr>
                                <td>5</td>
                                <td>Total Full Cycles
                                    Full Charge (Slow)
                                    Full Charge (Fast)
                                </td>
                                <td>Total number of Full charging cycles where End SoC = 100
                                    Total number of slow charging cycles where End SoC = 100
                                    Total number of fast charging cycles where End SoC = 100
                                    for selected date range
                                </td>
                                <td>Sum (charging Cycles where End SoC = 100 and charge type = Slow and Fast)
                                    Sum (charging Cycles where End SoC = 100 and charge type = Slow )
                                    Sum (charging Cycles where End SoC = 100 and charge type = Fast )
                                </td>
                            </tr> <tr>
                                <td>6</td>
                                <td>Median gun duration (min)
                                </td>
                                <td>Median of Difference between Gun end time and Gun start time
                                </td>
                                <td>Median (Gun End Time - Gun Start Time)
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Median Delta SOC (%)
                                </td>
                                <td>Median of Difference between end and start Soc
                                </td>
                                <td>Median (End_SoC - Start_Soc)
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Median energy added (Kwh)
                                </td>
                                <td>Median of Difference between start and end BMS pack * voltage
                                </td>
                                <td>Median (End BMS Pack_Ah * End BMS Pack_Voltage - Start BMS Pack_Ah* Start BMS Pack_Voltage)
                                </td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Median ROC (%/hr)
                                </td>
                                <td>Median of Delta soc divided by charge duration (mins)
                                </td>
                                <td>Median [Delta SoC/(Charge Duration /60)]
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>Median HV Battery max temp (  ̊C)
                                </td>
                                <td>Median of Max BMS Max Cell temp(  ̊C)
                                </td>
                                <td>Median [Max (BMS Max Cell temp(  ̊C))]
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>Median 20-100 % time and 10% to 80% (min)
                                </td>
                                <td>Median of Time difference between 1st record of 20% Soc and 1st record of 100% and minus charge interuption time
                                </td>
                                <td>Median (Time in which SOC reached 100% - time in which SOC reached 20 %) - charge interrupt time between this time.
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Median No. of Interruptions
                                </td>
                                <td>Count of HV_Charge_Indication=0 between a gun cycle
                                </td>
                                <td>Median (No. of interruption)
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Median OBC max temp (  ̊C)
                                </td>
                                <td>Median of Max OBC temp (  ̊C)</td>
                                <td>Median [Max (OBC temperature (  ̊C))]</td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>Charge duration (min)
                                </td>
                                <td>Median of difference between Gun Duration, Gun After Full Charge, Time before charge start, Charge Interrupt time
                                </td>
                                <td>Median (Gun Duration - Gun After Full Charge -Time before charge start -Charge Interrupt time).
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>Charge Interrupt time (min)
                                </td>
                                <td>Median of Time between HV_Charge_Indication = 0 between a gun cycle
                                </td>
                                <td>Median (charge interruption time)
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>Gun after full charge (min)
                                </td>
                                <td>Median of Difference between Gun end time and Charge End time</td>
                                <td>Median (Gun End Time - Charge End Time)</td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>Max Coolant in temprature (  ̊C)
                                </td>
                                <td>Max of BMS_Max_coolant_in during gun connected</td>
                                <td>Max ( max_bcs_coolant_in)</td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>Max Coolant out temprature (   ̊C)
                                </td>
                                <td>Max of BMS_coolant_out during gun connected</td>
                                <td>Max (max_bcs_coolant_out)</td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>Max_BMS_Max_Cell_Voltage (V)
                                </td>
                                <td>Max of BMS_Max_Cell_Voltage during gun connected</td>
                                <td>Max (bms_max_cell_voltage)</td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>Max_BMS_Min_Cell_Voltage (V)
                                </td>
                                <td>Max of BMS_Min_Cell_Voltage during gun connected</td>
                                <td>Max (bms_min_cell_voltage)</td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>BMS_max_cell_voltage_charge_end (V)
                                </td>
                                <td>BMS_Max_Cell_Voltage at charge end</td>
                                <td>bms_max_cell_voltage_charge_end @ charge end</td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>BMS_min_cell_voltage_charge_end (V)
                                </td>
                                <td>BMS_Min_Cell_Voltage at charge end</td>
                                <td>bms_min_cell_voltage_charge_end @ charge end</td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>delta_cell_voltage_charge_end (mV)
                                </td>
                                <td>Difference between max and min BMS cell voltage at charge end</td>
                                <td>BMS_max_cell_voltage_charge_end - BMS_min_cell_voltage_charge_end</td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>delta_cell_voltage_after_2_hour_time
                                </td>
                                <td>2 hours plus time stamp after the charge end where either HV_Charge_Indication in either 0 or 1</td>
                                <td>Timestamp @(&gt;= 2 hours Charge end) and HV_Charge_Indication 0 or 1</td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>BMS_max_cell_voltage_after_2_hour (V)
                                </td>
                                <td>Max BMS cell voltage at charge end after 2 hours</td>
                                <td>bms_max_cell_voltage_after_2_hour @ delta_cell_voltage_after_2_hour_time</td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>BMS_min_cell_voltage_after_2_hour (V)
                                </td>
                                <td>Min BMS cell voltage at charge end after 2 hours</td>
                                <td>bms_min_cell_voltage_after_2_hour @ delta_cell_voltage_after_2_hour_time</td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>delta_cell_voltage_after_2_hour (V)
                                </td>
                                <td>Difference between max and min BMS cell voltage at 2 hours of charge end</td>
                                <td>BMS_max_cell_voltage_after_2_hour - BMS_min_cell_voltage_after_2_hour</td>
                            </tr>
                        </tbody>
                    </table>
                </body>
            </DashboardMain>
        </>
    );
}

export default GlossaryPageFaultanalysis;